import React from 'react'
import styled from '@emotion/styled/macro'
import mq from 'mediaQuery'
import useDarkMode from 'use-dark-mode'

const Step = ({ image, text, title }) => {
  const darkMode = useDarkMode()
  const isDark = darkMode.value

  return (
    <Container className="grid-element" isDark={isDark}>
      <img src={image} alt="step" style={{ margin: 'auto', display: 'flex' }} />
      <H3Bold isDark={isDark}>{title}</H3Bold>
      <B2Medium isDark={isDark}>{text}</B2Medium>
    </Container>
  )
}

export default Step

const Container = styled('div')`
  padding: 40px 30px;
  background: ${({ isDark }) => (isDark ? '#5E17FE' : '#fff')};
  border: 1px solid #000000;
  border-radius: 20px;
`

const H3Bold = styled('div')`
  margin-top: 20px;
  margin-bottom: 13px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: -0.25px;
  color: ${({ isDark }) => (isDark ? '#fff' : '#000')};
`

const B2Medium = styled('div')`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${({ isDark }) => (isDark ? '#fff' : '#000')};
`
